<template>
	<div id="app">
		<localization></localization>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Localization from '@/localization'
import moment from 'moment'
import { USER as USER_ACTIONS } from './store/actions'
export default {
	name: 'app',
	components: { Localization },
	data() {
		return {
			moment,
		}
	},
	created() {
		if (this.getRefresh) {
			const duration = moment.duration(moment(new Date()).diff(this.getRefresh))
			if (duration.asHours() > 4) {
				this.$store.dispatch(USER_ACTIONS.LOGOUT)
				this.$notification.info('Session expired', 'Please signin again')
			}
		} else {
			this.$store.dispatch(USER_ACTIONS.LOGOUT)
			this.$notification.info('Session expired', 'Please signin again')
		}
	},
	computed: {
		...mapGetters(['getCurrentUser', 'getRefresh']),
		nextRoute() {
			return this.$route.query.redirect || '/'
		},
	},
	watch: {
		getCurrentUser(auth) {
			if (auth) {
				this.$router.replace(this.nextRoute)
			} else {
				this.$router.replace('/auth/login')
			}
		},
		$route(to, from) {
			const query = Object.assign({}, to.query)
			this.$store.commit('SETUP_URL_SETTINGS', query)
		},
	},
}
</script>
